import React from 'react'

export const AdminPanel = () => {
  return (
    <div>
        <h1>Admin Panel</h1>
    </div>
  )
}
